import { API, Buffer } from '../core';

/**
 * This post-processor plugin registers keys used by a front-end software, allowing us to
 * determine keys usage later on and flag obsolete or outdated keys.
 */
export class TeesterPostProcessor {
    constructor ({ url, template } = {}) {
        this.type = 'postProcessor';
        this.name = 'usage';
        this.api = new API({ url, template });
        this.buffer = new Buffer({ onFlush: this.api.reportUsage.bind(this.api) });
    }

    /**
     * Intercept the translated value
     */
    process (value, [key]) {
        this.buffer.add(key);
        return value;
    }
}
